import { atomWithStorage } from 'jotai/utils';
import type { JobFilters, PaginationConfig } from '@repo/types';

/**
 * Job filters atom with localStorage persistence
 * Persists user filter selections across page navigation and browser sessions
 */
export const jobFiltersAtom = atomWithStorage<JobFilters>('oubo-job-filters', {
  status: undefined,
  scoutId: undefined,
  category: undefined,
  location: undefined,
  industry: undefined,
  jobTitle: undefined,
  jobType: undefined,
  workMode: undefined,
  search: undefined,
  dateRange: undefined,
  source: undefined,
});

/**
 * Job pagination atom with localStorage persistence
 * Persists pagination settings across page navigation
 */
export const jobPaginationAtom = atomWithStorage<Omit<PaginationConfig, 'total'>>('oubo-job-pagination', {
  page: 1,
  limit: 20,
  sortBy: 'createdAt',
  sortOrder: 'desc',
});

/**
 * Reset filters to default values
 */
export const resetJobFilters = (): JobFilters => ({
  status: undefined,
  scoutId: undefined,
  category: undefined,
  location: undefined,
  industry: undefined,
  jobTitle: undefined,
  jobType: undefined,
  workMode: undefined,
  search: undefined,
  dateRange: undefined,
  source: undefined,
});
